import { DisplayExamDate, Loader, Error } from '../../common'
import { ProcessButton } from '../common/detail'
import ProcessApprovalRequestForm from '../../../containers/forms/ProcessApprovalRequestForm'
import { fetchApprovalRequestDetail } from '../../../actions/approvalRequests'
import {
  selectSelectedApprovalRequest,
  getApprovalRequestProcessing,
  selectSpecificApprovalRequestType,
  selectSelectedEducationPeriod,
} from '../../../selectors/approvalRequests'
import {
  APPROVAL_REQUEST_CONFIG,
  SPECIAL_ORDER_TYPE_SECURE,
} from '../../../constants/ApprovalRequestConstants'
import { sortColumnByKey } from '../../../utils/sort'

const mapStateToProps = state => {
  const approvalRequest = selectSelectedApprovalRequest(state)
  const isSecureMaterial = approvalRequest.specialOrderType === SPECIAL_ORDER_TYPE_SECURE
  approvalRequest.items = sortColumnByKey(approvalRequest.items, 'description', 'asc')
  return {
    approvalRequest,
    arType: selectSpecificApprovalRequestType(state),
    processingApprovalRequest: getApprovalRequestProcessing(state),
    isSecureMaterial,
    educationPeriodCd: selectSelectedEducationPeriod(state),
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      fetchApprovalRequestDetail,
    },
    dispatch
  )

const dataBlockStyle = { marginBottom: '1em' }
const headerStyle = { fontFamily: 'Roboto,sans-serif', fontSize: '.9rem', fontWeight: 'bold' }
const valueStyle = { fontSize: '.875rem' }

class Request extends Component {
  componentDidMount() {
    const { approvalRequest, arType, fetchApprovalRequestDetail } = this.props
    const id = approvalRequest[APPROVAL_REQUEST_CONFIG[arType].idField]
    fetchApprovalRequestDetail(id, arType)
  }

  componentDidUpdate(prevProps) {
    const { approvalRequest, arType, fetchApprovalRequestDetail } = this.props
    const id = approvalRequest[APPROVAL_REQUEST_CONFIG[arType].idField]

    if (prevProps.approvalRequest[APPROVAL_REQUEST_CONFIG[arType].idField] !== id) {
      fetchApprovalRequestDetail(id, arType)
    }
  }

  render() {
    const {
      approvalRequest,
      approvalRequest: {
        aiCode,
        orgName,
        course,
        description,
        examDate,
        examDateType,
        items = [],
        quantity,
        quantityOrdered = 0,
        examCount = 0,
        reasonForOrder,
        fetching,
        error,
      },
      isSecureMaterial,
      processingApprovalRequest,
      educationPeriodCd,
    } = this.props
    const cdsOrdered = items.map(item => item.cdsOrdered).join(', ')

    if (error) {
      return <Error message={error} />
    }

    if (fetching) {
      return <Loader />
    }

    return (
      <>
        <div className="row">
          <div className="col-xs-12" style={dataBlockStyle}>
            <h4 style={headerStyle}>School</h4>
            <div style={valueStyle}>
              {aiCode} <span style={{ marginLeft: '25px' }}>{orgName}</span>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6 col-xs-12" style={dataBlockStyle}>
            <h4 style={headerStyle}>Course</h4>
            <div style={valueStyle}>{isSecureMaterial ? course : 'N/A'}</div>
          </div>
          <div className="col-sm-6 col-xs-12" style={dataBlockStyle}>
            <h4 style={headerStyle}>Exam Date</h4>
            <span style={valueStyle}>
              <DisplayExamDate data={approvalRequest} educationPeriodCd={educationPeriodCd} />
            </span>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <table style={{ marginBottom: '1em' }}>
              <thead>
                <tr>
                  <th
                    id="materialQtyCol"
                    scope="col"
                    style={{ whiteSpace: 'nowrap', paddingRight: '12px' }}
                  >
                    Add&apos;l Qty
                  </th>
                  <th id="materialNameCol" scope="col">
                    Material
                  </th>
                </tr>
              </thead>
              <tbody>
                {isSecureMaterial ? (
                  items.map(item => (
                    <tr key={item.ancillaryCd}>
                      <td headers="materialQtyCol">{item.quantity}</td>
                      <td headers="materialNameCol">{item.description}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td headers="materialQtyCol">{quantity}</td>
                    <td headers="materialNameCol">{description}</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6 col-xs-12" style={dataBlockStyle}>
            <h4 style={headerStyle}>Test Takers</h4>
            <div style={valueStyle}>{isSecureMaterial ? examCount : 'N/A'}</div>
          </div>
          <div className="col-sm-6 col-xs-12" style={dataBlockStyle}>
            <h4 style={headerStyle}>{isSecureMaterial ? 'CDs Fulfilled' : 'Qty. Approved'}</h4>
            <div style={valueStyle}>{isSecureMaterial ? cdsOrdered : quantityOrdered}</div>
          </div>
        </div>
        {reasonForOrder && (
          <div className="row">
            <div className="col-xs-12" style={{ marginBottom: '1.5em' }}>
              <h4 style={headerStyle}>Reason</h4>
              <div style={valueStyle}>{reasonForOrder}</div>
            </div>
          </div>
        )}
        <div className="row">
          <div className="col-xs-12" style={{ marginBottom: '1.5em' }}>
            {processingApprovalRequest ? <ProcessApprovalRequestForm /> : <ProcessButton />}
          </div>
        </div>
      </>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Request)
